import axiosModule from "@/util/axios-module";
import { ErrorWrapper, ResponseWrapper } from "@/services/util";

export class SessionService {
  static async NewSession(deviceId) {
    try {
      const response = await axiosModule.get(
        `rdcSession/createSession?deviceId=${deviceId}`
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async JoinSession(session) {
    try {
      const response = await axiosModule.post(
        "rdcSession/joinSession",
        session
      );
      return new ResponseWrapper(response, response.data);
    } catch (exception) {
      throw new ErrorWrapper(exception);
    }
  }

  static async DestroySession(session) {
    if (session) {
      try {
        const response = await axiosModule.post(
          "rdcSession/exitSession",
          session
        );
        return new ResponseWrapper(response, response.data);
      } catch (exception) {
        throw new ErrorWrapper(exception);
      }
    }
  }
}
